import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import TvTheater from './tvTheater';
import TvSideslip from './tvSideslip';

class TvHall extends React.PureComponent {
    static propTypes = {
        hitTv1: PropTypes.array,
        hitTv2: PropTypes.object,
        isVideoShare: PropTypes.bool,
    };

    render() {
        const { hitTv1, hitTv2, isVideoShare } = this.props;

        return (
            <>
                <TvTheater hitTv1={hitTv1} isVideoShare={isVideoShare} />
                <TvSideslip hitTv2={hitTv2} isVideoShare={isVideoShare} />
            </>
        );
    }
}

export default errorBoundary(TvHall);
